<div class="container-fluid sanofi-rules-cont" id="main-container">
    <h1><b>Sanofi Rules - </b></h1>
    <br><br>

    <table id="backoffice-table" class="backoffice-table display">
        <thead>
            <tr class="heading">
                <th class="code">Sanofi Rule Code</th>
                <th class="description">Rule Description</th>
                <th class="values">Values</th>
                <th class="upload">Upload File</th>
                <th class="download">Download</th>
            </tr>
        </thead>
        <tbody class="datatable-row" *ngIf="sanofiRulesArr?.length > 0">
            <tr *ngFor="let sanofiRule of sanofiRulesArr; let i = index" class="sanofirules-body">
                <td>{{sanofiRule.code}}</td>
                <td>{{sanofiRule.name}}</td>
                <td [innerHTML]="sanofiRule.values" class="values_data"></td>

                <td>
                    <!-- <form [formGroup]="sanofiRulesForm" (ngSubmit)="uploadFileDetails()"> -->
                        <div class="browse-btn-group">
                            <input type="text" readonly 
                            class="Fields-input browse-input browse-inputFLU_HIDE_ORDER"
                            [value]="getSelectedFileName(i)">

                            <input type="file" id="sts-input-fileFLU_HIDE_ORDER" name="excelFile" data-id="FLU_HIDE_ORDER" 
                            (change)="onFileSelect($event,i)" 
                            #fileUpload
                            class="hide" value="" data-di-id="#sts-input-fileFLU_HIDE_ORDER"
                            accept=".xls,.xlsx">

                            <button type="button" class="btn btn-default browse-btn blu-btn sanofi-rules-page-btn" id="browse-btn" data-id="FLU_HIDE_ORDER" data-di-id="#browse-btn"
                            (click)="refreshValue(i); fileUpload.click();">
                            Browse</button>

                            <button type="submit" class="sanofi-rules-page-btn btn btn-default browse-btn blu-btn button upload uploadFLU_HIDE_ORDER" 
                            [disabled]="!getSelectedFileName(i) || excelFileInvalidStatus"
                            (click)="uploadFileDetails(sanofiRule.code,i)">
                            <i class="fa fa-spinner fa-spin" *ngIf="getUploadClicked(i)"></i>
                            Upload</button>
                        </div>
                    <!-- </form> -->
                </td>
               <td class="center-download-button">
                    <button type="button" class="btn btn-default browse-btn stsblue-button upload sanofi-rules-page-btn sanofi-rules-page-dnld-btn"
                    (click)="downloadExcel(sanofiRule.code)">Download</button>
                </td>
            </tr>
        </tbody>
    </table>
        <div class="no-rules" *ngIf="sanofiRulesArr===undefined || sanofiRulesArr?.length === 0">There is no data to display</div>
    <br><br><br><br>
</div>